export const firebaseConfig = {
    "projectId": "guidde-dev3",
    "appId": "1:912904406324:web:a1c1bd34274ec9063a1161",
    "databaseURL": "https://guidde-dev3-default-rtdb.firebaseio.com",
    "storageBucket": "guidde-dev3.appspot.com",
    "locationId": "us-central",
    "apiKey": "AIzaSyCb662XeXbw2AV658Zb5A7CmBbw_a2XLhw",
    "authDomain": "dev3.guidde.com",
    "messagingSenderId": "912904406324",
    "projectNumber": "912904406324",
    "version": "2",
    "stiggApiKey": "client-5759ff8a-56b4-4214-8ca2-b89844ae8fd3:0bd8f132-b309-46b2-b611-146a5c7a2d8f",
    "stiggEnv": "guidde-dev3",
    "environment": "guidde-dev3"
}

export const BRAND_FETCH_CLIENT_KEY =
'1idzwFOduCW-kJxvD50'
export const ENABLE_SAOLA =
'false'
export const GDRIVE_PICKED_API_KEY =
'AIzaSyDIylkJ-gGIH729Cihyf2BM4GJAPeosWFA'
export const MIXPANEL_SESSION_REPLAY_PERCENT =
'10'
export const MIXPANEL_TOKEN =
'd287c9d57dcabe3765cd10c3da69b39e'
export const SAOLA_ACCOUNT_TOKEN =
'856f10ef-4168-4be6-8d73-06030e21a9a0'
export const STIGG_API_KEY =
'client-5759ff8a-56b4-4214-8ca2-b89844ae8fd3:0bd8f132-b309-46b2-b611-146a5c7a2d8f'
export const STIGG_BASE_URL =
'https://api.stigg.io'
export const STIGG_CLIENT_KEY =
'client-5759ff8a-56b4-4214-8ca2-b89844ae8fd3:0bd8f132-b309-46b2-b611-146a5c7a2d8f'
export const STIGG_CLIENT_SDK_POLLING_INTERVAL_MS =
'10000'
export const STIGG_EDGE_URL =
'https://edge.api.stigg.io'
export const STIGG_ENV =
'guidde-dev3'
export const WEB_CLIENT_ID =
'912904406324-f967s35v3cjfvqccjg18vtuuj2u0k1a6.apps.googleusercontent.com'
export const entailApiKey =
'et-WJgibNJi14XN2kj8esMTq2ke_JhVpI8n5kq0lPv1-2eEnbIv'
export const isSeparateNetworkIssuesInMonitoring =
'True'
export const stripeKey =
'pk_test_51OqX1AGiCZljVMTQ1XY3nP1leOVRIya586xaIGWa8pfrU7yjWCbMsGKj6yd1chzp3CRgXTPQ54wvS4Xeds5JBU1B00h7l5ynnl'
export const tapfiliateAccountId =
'47910-93439a'